import { isInShell } from '../services/nativeBridge/shellPresence';

const inAppRegExps = [
  'WebView',
  '(iPhone|iPod|iPad)(?!.*Safari/)', // Apple devices but not with "Safari/" following
  'Android.*wv\\)',
  'FB_\\w|FB\\w', // Match Facebook FB_ or FB then word char
  'Snapchat',
] as const;

export const inappRegex = new RegExp(`${inAppRegExps.map((reg) => `(${reg})`).join('|')}`, 'ig');

export const isInAppBrowser = window.navigator.userAgent.match(inappRegex) !== null;

/**
 * Whether Google sign-in must be refused here. Google blocks its own OAuth page inside a detected
 * WebView, so a foreign in-app browser (Facebook's, Snapchat's) is refused. The mobile shell is a
 * WebView too, and matches `inappRegex` on both platforms — but there sign-in runs through the shell's
 * native Google SDK instead of the web page, so it is not blocked.
 *
 * A function, not a constant: the shell's presence is settled after load.
 */
export const isGoogleSignInBlocked = (): boolean => isInAppBrowser && !isInShell();
